enum LoadingStates {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export { LoadingStates };
